// leave in this line to fix IE (https://sentry.io/organizations/zgny/issues/1886423680/)
import "core-js/features/array/includes";

import React from "react";
import { func, node, string } from "prop-types";

import { POSITION } from "./constants";

const { ALL, BOTTOM, LEFT, RIGHT, TOP } = POSITION;

class TooltipPositioner extends React.Component {
  componentDidMount() {
    this.setPosition();
  }

  setPosition = () => {
    const {
      getTooltipElem,
      getTriggerElem,
      position,
      updatePosition
    } = this.props;

    const tooltipElem = getTooltipElem();
    const triggerElem = getTriggerElem();

    let collision = {};
    let nextPosition = position;

    if (window && tooltipElem) {
      collision = this.detectedCollision({
        win: window,
        elem: tooltipElem.getBoundingClientRect(),
        triggerElem: triggerElem.getBoundingClientRect()
      });
    }

    if (collision.detected) {
      if (collision.freePositions.includes(position)) {
        nextPosition = position;
      } else if (collision.freePositions.includes(RIGHT)) {
        nextPosition = RIGHT;
      } else if (collision.freePositions.includes(BOTTOM)) {
        nextPosition = BOTTOM;
      } else if (collision.freePositions.includes(LEFT)) {
        nextPosition = LEFT;
      } else if (collision.freePositions.includes(TOP)) {
        nextPosition = TOP;
      }
    }

    updatePosition(nextPosition);
  };

  detectedCollision = ({ elem, triggerElem, win }) => {
    let detectedCollision = false;
    let collisionPositions = [];
    const winWidth =
      win.document.documentElement.clientWidth || win.document.body.clientWidth;
    const triangleSize = 10;
    const willCollideOnRight =
      triggerElem.x + triggerElem.width + triangleSize + elem.width >
        winWidth ||
      triggerElem.y + triggerElem.height + triangleSize + elem.height / 2 >
        win.innerHeight;
    const willCollideOnLeft =
      triggerElem.x - triggerElem.width - triangleSize - elem.width < 0 ||
      triggerElem.y + triggerElem.height + triangleSize + elem.height / 2 >
        win.innerHeight;
    const willCollideOnBottom =
      triggerElem.y + triangleSize + elem.height > win.innerHeight ||
      triggerElem.x + elem.width / 2 > winWidth;
    const willCollideOnTop =
      triggerElem.y - triangleSize - elem.height < 0 ||
      triggerElem.x + triggerElem.width + triangleSize + elem.width / 2 >
        winWidth;

    if (willCollideOnBottom) {
      collisionPositions = [...collisionPositions, BOTTOM];
      detectedCollision = willCollideOnBottom;
    }

    if (willCollideOnRight) {
      collisionPositions = [...collisionPositions, RIGHT];
      detectedCollision = willCollideOnRight;
    }

    if (willCollideOnLeft) {
      collisionPositions = [...collisionPositions, LEFT];
      detectedCollision = willCollideOnLeft;
    }

    if (willCollideOnTop) {
      collisionPositions = [...collisionPositions, TOP];
      detectedCollision = willCollideOnTop;
    }

    return {
      detected: detectedCollision,
      freePositions: ALL.filter(pos => !collisionPositions.includes(pos))
    };
  };

  render() {
    return this.props.children;
  }
}

TooltipPositioner.propTypes = {
  children: node,
  position: string,
  getTooltipElem: func.isRequired,
  getTriggerElem: func.isRequired,
  updatePosition: func
};

TooltipPositioner.defaultProps = {
  children: null,
  position: RIGHT,
  updatePosition: () => {}
};

export default TooltipPositioner;
